import React from "react";

const KitchenPrint = React.forwardRef(
  ({ products, userName, orderId, cellphone }, ref) => (
    <div ref={ref} className="kitchen-print">
      <div className="invoice">
        <h5>
          <span className="fw-bold">Nombre: </span>
          {userName || "Cliente"}
        </h5>
        {cellphone && (
          <h5>
            <span className="fw-bold">Celular: </span>
            {cellphone}
          </h5>
        )}
        <h5>
          <span className="fw-bold">Orden#: </span>
          {orderId}
        </h5>
        <ul>
          {products?.length &&
            products.map((product, index) => (
              <li key={index}>
                <span className="product-name">
                  {index + 1}. {product.productName}
                </span>
                {product.changes && (
                  <div>
                    <small className="invoice-details">
                      <span>Cambios:</span> {product.changes}
                    </small>
                  </div>
                )}
                {product.sauces && (
                  <div className="invoice-details">
                    <small>
                      <span>Salsas:</span> {product.sauces}
                    </small>
                  </div>
                )}
              </li>
            ))}
        </ul>
      </div>
    </div>
  )
);

KitchenPrint.displayName = "KitchenPrint";

export default KitchenPrint;
